import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { SectionCard } from "shared/app/LeadsTableView/components/CreateLeadModal/SectionCard";
import { useFormController } from "shared/app/LeadsTableView/components/CreateLeadModal/useFormController";
import { DateInput, InputSize, Select, TextArea } from "shared/components";
import { LeadSource } from "views/leads-id/types";

export const DetailsSection = ({
  form
}: {
  form: ReturnType<typeof useFormController>;
}) => {
  const { data: sourceOptions, isLoading } = useQuery({
    queryKey: ["LEAD_SOURCES"],
    queryFn: () => {
      return instance
        .get<{ items: LeadSource[] }>("/portal/v1/boom_crm/lead_sources")
        .then((res) => res.data)
        .then((data) =>
          data.items.map((source) => ({
            label: source.name,
            value: String(source.id)
          }))
        );
    }
  });

  return (
    <SectionCard title="Details">
      <div className="flex flex-col gap-6">
        {/* Row 1: Source (with icon) + Desired move-in (3 selects) */}
        <div
          className="grid gap-4 w-full max-w-[752px]"
          style={{ gridTemplateColumns: "repeat(2,minmax(0,1fr))" }}
        >
          <div className="w-full max-w-[368px] flex flex-col gap-1">
            <Select
              menuPosition="fixed"
              clearable
              id="sourceEdit"
              size={InputSize.SM}
              label="Source"
              loading={isLoading}
              key={sourceOptions ? "loaded" : "loading"}
              value={form.values.source_id}
              onChange={(e) =>
                form.handleChange("source_id", () => e.target.value)()
              }
              options={sourceOptions || []}
              legacyErrorMargins={false}
            />
          </div>
          <div className="w-full max-w-[368px] flex flex-col gap-1">
            <DateInput
              menuPosition="fixed"
              id="desiredMoveIn"
              label="Desired move-in"
              size={InputSize.SM}
              value={form.values.desired_move_in_date}
              onChange={(e) => form.setDesiredMoveInDate(e.target.value)}
            />
          </div>
        </div>
        {/* Message full width */}
        <div className="w-full max-w-[752px]">
          <TextArea
            id="message"
            label="Message"
            value={form.values.message}
            size={InputSize.BASE}
            placeholder="Message"
            onChange={(e) => form.setMessage(e.target.value)}
            autoExpand
            legacyErrorMargins={false}
            className="text-sm font-medium"
          />
        </div>
      </div>
    </SectionCard>
  );
};
